import { getStaticImageSrc } from 'utils/getImageSrc';

import {
  IdealistLogoContainer,
  IdealistLogoMarkImg,
  IdealistLogoStaffMarkerImg,
  IdealistLogoTextImg,
} from './IdealistLogo.styled';

type Props = {
  height: number | { mobile: number; desktop: number };
  withText?: boolean;
  withStaffMarker?: boolean;
};

export function IdealistLogo({ height, withText, withStaffMarker }: Props) {
  return (
    <IdealistLogoContainer
      $heightMobile={typeof height === 'number' ? height : height.mobile}
      $heightDesktop={typeof height === 'number' ? height : height.desktop}
    >
      <IdealistLogoMarkImg
        src={getStaticImageSrc('logos/logo-mark.webp')}
        srcSet={[
          getStaticImageSrc('logos/logo-mark.webp'),
          `${getStaticImageSrc('logos/logo-mark@2x.webp')} 2x`,
          `${getStaticImageSrc('logos/logo-mark@3x.webp')} 3x`,
        ].join(', ')}
        alt="Idealist logo"
      />

      {withText && (
        <IdealistLogoTextImg
          src={getStaticImageSrc('logos/logo-idealist.svg')}
          alt="idealist"
        />
      )}

      {withStaffMarker && (
        <IdealistLogoStaffMarkerImg
          src={getStaticImageSrc('logos/logo-staff.svg')}
          alt="staff"
        />
      )}
    </IdealistLogoContainer>
  );
}
